import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Contact } from './components/Contact';
import { Services } from './components/Services';
import { Process } from './components/Process';
import { Testimonials } from './components/Testimonials';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
import { WhyChooseMe } from './components/WhyChooseMe';
import { Portfolio } from './components/Portfolio';
import { ServicesPage } from './components/pages/ServicesPage';
import { ProcessPage } from './components/pages/ProcessPage';
import { TestimonialsPage } from './components/pages/TestimonialsPage';
import { AboutPage } from './components/pages/AboutPage';
import { SupportPage } from './components/pages/SupportPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="w-full min-h-screen bg-white" data-id="element-1">
        <Header data-id="element-2" />
        <Routes data-id="element-3">
          <Route path="/" element={<>
                <Hero data-id="element-5" />
                <Contact data-id="element-6" />
                <WhyChooseMe data-id="element-7" />
                <Services data-id="element-8" />
                <Process data-id="element-9" />
                <Testimonials data-id="element-10" />
                <CTA data-id="element-11" />
              </>} data-id="element-4" />
          <Route path="/portfolio" element={<Portfolio data-id="element-13" />} data-id="element-12" />
          <Route path="/services" element={<ServicesPage data-id="element-15" />} data-id="element-14" />
          <Route path="/process" element={<ProcessPage data-id="element-17" />} data-id="element-16" />
          <Route path="/testimonials" element={<TestimonialsPage data-id="element-19" />} data-id="element-18" />
          <Route path="/about" element={<AboutPage data-id="element-21" />} data-id="element-20" />
          <Route path="/support" element={<SupportPage data-id="element-23" />} data-id="element-22" />
        </Routes>
        <Footer data-id="element-24" />
      </div>
    </BrowserRouter>;
}